/* eslint-disable */
export default function capitalizeFirstLetter(data) {
    return data.charAt(0).toUpperCase() + data.slice(1)
}
